import React from 'react';
import { Project } from '../../types/Project';
import ProducerControlPanel from '../ProducerComponents/ProducerControlPanel/ProducerControlPanel';
import ProjectUserControlPanel from '../ProjectUserComponents/ProjectUserControlPanel/ProjectUserControlPanel';

import './ProjectControlPanel.scss';
import { UserType, UserTypeEnum } from '../../types/enums/UserTypesEnum';
import { Messages } from '../../types/Message';

type ProjectControlPanelProps = {
  userType: UserType;
  token: string;
  chatMessages: Messages;
  sendMessageToRoomCallback: (messageToSend: string) => void;
  isChatConnected: boolean;
  sendProjectToAllUsers: (project: Project) => void;
};

const ProjectControlPanel = (props: ProjectControlPanelProps) => {
  return (
    <div className="control-panel">
      {props.userType === UserTypeEnum.Producer ? (
        <ProducerControlPanel
          chatMessages={props.chatMessages}
          sendMessageToRoomCallback={props.sendMessageToRoomCallback}
          isChatConnected={props.isChatConnected}
          sendProjectToAllUsers={props.sendProjectToAllUsers}
        />
      ) : (
        <ProjectUserControlPanel
          chatMessages={props.chatMessages}
          token={props.token}
          sendMessageToRoomCallback={props.sendMessageToRoomCallback}
          isChatConnected={props.isChatConnected}
          userType={props.userType}
          sendProjectToAllUsers={props.sendProjectToAllUsers}
        />
      )}
    </div>
  );
};

export default ProjectControlPanel;
